import { render, staticRenderFns } from "./CrmGrid.vue?vue&type=template&id=44034ae4&"
import script from "./CrmGrid.vue?vue&type=script&lang=ts&"
export * from "./CrmGrid.vue?vue&type=script&lang=ts&"
import style0 from "./CrmGrid.vue?vue&type=style&index=0&id=44034ae4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports